import backgroundImage from '../../assets/img/bgd.jpg';
import backgroundImageLate from '../../assets/img/bgt.jpeg';

export function useBackgroundImage() {
  const time = new Date().getHours();

  return time >= 18 && time <= 21 ? backgroundImageLate : backgroundImage;
}
